import { z } from 'zod';

export const $CandidateActivitySphere = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  code: z.string().nullable(),
});
